import { Grid } from 'antd';

const useDesktopDetection = (targetSize) => {
  const screens = Grid.useBreakpoint()
  return screens[targetSize ?? 'md']
}

export default useDesktopDetection